import React, {FC, useRef} from 'react';
import style from './style.module.scss';
import {ProductCard} from 'modules/products/components/ProductCard';
import {PRODUCT_LIST_VIEW} from 'modules/products/constants';
import classNames from 'classnames';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';
import {IProductShort} from 'modules/products/types';
import {useInfiniteScroll} from 'core/hooks/useInfiniteScroll';

interface IProps {
    products?: IProductShort[];
    className?: string;
    onLoadMore?: () => void;
    infiniteScrollActive?: boolean;
}

export const ProductsPageBlock: FC<IProps> = ({products, className, onLoadMore, infiniteScrollActive = true}) => {
    const boundaryRef = useRef<HTMLDivElement>(null);

    useInfiniteScroll({
        boundaryRef,
        onScrollToBoundary: onLoadMore || (() => {}),
        active: Boolean(infiniteScrollActive && onLoadMore),
        margin: '200px 0px',
        threshold: [0],
    });

    return (
        <ProductSnippetAnalyticsProvider>
            <div className={classNames(style.products, style.productsFlexible, className)}>
                {products?.map((product) => {
                    return (
                        <div key={product.id}>
                            <ProductCard
                                {...product}
                                className={style.productListItem}
                                listType={PRODUCT_LIST_VIEW.tile}
                                tracking={{skipOnViewTracking: false}}
                            />
                        </div>
                    );
                })}
                <div ref={boundaryRef} />
            </div>
        </ProductSnippetAnalyticsProvider>
    );
};
